import { INBOUND_PING_POST_REPORT_LOAD_REPORT_DATA_ACTION } from '../action-types';
import { INBOUND_PING_POST_REPORT_UPDATE_SHOW_ACTIVE_MUTATION, INBOUND_PING_POST_REPORT_UPDATE_START_DATE_AND_TIME_MUTATION,
    INBOUND_PING_POST_REPORT_UPDATE_END_DATE_AND_TIME_MUTATION, INBOUND_PING_POST_REPORT_UPDATE_CAMPAIGN_ID_MUTATION,
    INBOUND_PING_POST_REPORT_UPDATE_CAMPAIGN_DATA_MUTATION, INBOUND_PING_POST_REPORT_UPDATE_PRODUCTS_MUTATION,
    INBOUND_PING_POST_REPORT_UPDATE_PARTNER_ID_MUTATION, INBOUND_PING_POST_REPORT_UPDATE_PARTNER_DATA_MUTATION,
    INBOUND_PING_POST_REPORT_UPDATE_PING_ID_MUTATION, INBOUND_PING_POST_REPORT_UPDATE_HOURS_MUTATION, 
    INBOUND_PING_POST_REPORT_UPDATE_PING_STATUS_MUTATION, INBOUND_PING_POST_REPORT_UPDATE_POST_STATUS_MUTATION,
    INBOUND_PING_POST_REPORT_CLEAR_INBOUND_PING_POST_REQUEST_MUTATION, INBOUND_PING_POST_REPORT_SHOW_ACTIVE_PARTNER_AND_CAMPAIGN_MUTATION,
    INBOUND_PING_POST_REPORT_SHOW_ALL_PARTNER_AND_CAMPAIGN_MUTATION, INBOUND_PING_POST_REPORT_LOAD_REPORT_DATA_MUTATION,
    INBOUND_PING_POST_REPORT_IS_FILTER_MODIFIED_MUTATION
} from '../mutation-types';
import commonFunctions from '../../mixin/common-function-mixins';
import appConstants from '../../utility/app-constants';
import reportService from '../../services/api/Reports';

export const namespaced = true;

// initial state
export const state = {
    inboundPingPostDetailsReportRequest: loadInboundPingPostDetailsReportRequest(),
    filtersShowActiveOnly: true,
    campaignData: [],
    campaignDropdownSource: [],
    partnerData: [],
    partnerDropdownSource: [],
    inboundPingPostReportData: [],
    isFilterModified: false
}

// actions
export const actions = {
    async [INBOUND_PING_POST_REPORT_LOAD_REPORT_DATA_ACTION]({ state,commit }) {
        const response = await reportService.getInboundPingPostDetails(state.inboundPingPostDetailsReportRequest);
        commit(INBOUND_PING_POST_REPORT_LOAD_REPORT_DATA_MUTATION, response.data);
        return response;
      },
}

// mutations
export const mutations = {
    [INBOUND_PING_POST_REPORT_UPDATE_SHOW_ACTIVE_MUTATION](state, value) {
        state.filtersShowActiveOnly = value;
    },
    [INBOUND_PING_POST_REPORT_UPDATE_START_DATE_AND_TIME_MUTATION](state, value) {
        state.inboundPingPostDetailsReportRequest.startDatetime = value;
    },
    [INBOUND_PING_POST_REPORT_UPDATE_END_DATE_AND_TIME_MUTATION](state, value) {
        state.inboundPingPostDetailsReportRequest.endDatetime = value;
    },
    [INBOUND_PING_POST_REPORT_UPDATE_CAMPAIGN_ID_MUTATION](state, value) {
        state.inboundPingPostDetailsReportRequest.campaignIDs = value;
    },
    [INBOUND_PING_POST_REPORT_UPDATE_CAMPAIGN_DATA_MUTATION](state, value) {
        state.campaignData = value;
        state.campaignDropdownSource = state.campaignData.filter(a => a.statusID == 1)
    },
    [INBOUND_PING_POST_REPORT_UPDATE_PRODUCTS_MUTATION](state, value) {
        state.inboundPingPostDetailsReportRequest.products = value;
    },
    [INBOUND_PING_POST_REPORT_UPDATE_PARTNER_ID_MUTATION](state, value) {
        state.inboundPingPostDetailsReportRequest.partnerID = value;
    },
    [INBOUND_PING_POST_REPORT_UPDATE_PARTNER_DATA_MUTATION](state, value) {
        state.partnerData = value;
        state.partnerDropdownSource = state.partnerData.filter(a => a.statusID == 1);
    },
    [INBOUND_PING_POST_REPORT_UPDATE_PING_ID_MUTATION](state, value) {
        state.inboundPingPostDetailsReportRequest.pingID = value;
    },
    [INBOUND_PING_POST_REPORT_UPDATE_HOURS_MUTATION](state, value) {
        state.inboundPingPostDetailsReportRequest.hour = value;
    },
    [INBOUND_PING_POST_REPORT_UPDATE_PING_STATUS_MUTATION](state, value) {
        state.inboundPingPostDetailsReportRequest.pingStatus = value;
    },
    [INBOUND_PING_POST_REPORT_UPDATE_POST_STATUS_MUTATION](state, value) {
        state.inboundPingPostDetailsReportRequest.postStatus = value;
    },
    [INBOUND_PING_POST_REPORT_CLEAR_INBOUND_PING_POST_REQUEST_MUTATION](state) {
        state.inboundPingPostDetailsReportRequest = loadInboundPingPostDetailsReportRequest();
        state.isFilterModified = false;
    },
    [INBOUND_PING_POST_REPORT_SHOW_ACTIVE_PARTNER_AND_CAMPAIGN_MUTATION](state) {
        state.campaignDropdownSource = state.campaignData.filter(a => a.statusID == 1);
        state.partnerDropdownSource = state.partnerData.filter(a => a.statusID == 1);
    },
    [INBOUND_PING_POST_REPORT_SHOW_ALL_PARTNER_AND_CAMPAIGN_MUTATION](state) {
        state.campaignDropdownSource = state.campaignData;
        state.partnerDropdownSource = state.partnerData;
    },
    [INBOUND_PING_POST_REPORT_LOAD_REPORT_DATA_MUTATION](state, data) {
        state.inboundPingPostReportData = data
    },
    [INBOUND_PING_POST_REPORT_IS_FILTER_MODIFIED_MUTATION](state, value) {
        state.isFilterModified = value
    },
}

function loadInboundPingPostDetailsReportRequest() {
    return { 
        startDatetime: commonFunctions.methods.subtractDateValue(new Date(), 1, 'ddd MM/DD/YYYY')+appConstants.reportStartDatetime,
        endDatetime: commonFunctions.methods.formatDate(new Date(), 'ddd MM/DD/YYYY')+appConstants.reportEndDatetime,
        campaignIDs: '',
        products: '',
        partnerID: '',
        pingID: '',
        hour: '',
        pingStatus: '',
        postStatus: ''
    }
}